import React from 'react';
import styled from 'styled-components';
import { useObject } from 'react-firebase-hooks/database'
import { NoticeDb } from '../../constants/firebaseConfig'

const StyledNotice = styled.div`
  background-color: white;
  opacity: 0.8;
  width: calc(100% - 8px);
  padding: 4px 12px;
  border-radius: 8px;
  position: absolute;
  bottom: 250px;
  margin: 2px 4px;
  .notice-message {
    font-weight: 200;
    color: #002060;
    vertical-align: bottom;
    font-size: 14px;
  }
  @media screen and (min-width: 540px) {
    bottom: 275px;
  }
`;

export default function MobileNotice() {
  const [snapshot, loading, error] = useObject(NoticeDb)

  if (loading || error) {
    return <></>
  }
  return (
    <StyledNotice>
      <small className="text-secondary">Announcement</small>
      <div>
        <span className="notice-message">{snapshot.val()}</span>
      </div>
    </StyledNotice>
  )
}